import SelectAgency from "./SelectAgency";
import React, { useEffect, useRef } from "react";
import {
  Col,
  FormFeedback,
  Input,
  Label,
  ModalBody,
  Row,
  Spinner,
  Form,
  Card,
  CardBody,
  Button,
} from "reactstrap";
import SelectCIType from "./SelectCIType";
import SimpleBar from "simplebar-react";
import Flatpickr from "react-flatpickr";

const ClassifiedinformationForm = ({
  validation,
  isUpdate,
  loading,
  setLoading,
  toggle,
}: {
  validation: any;
  isUpdate: boolean;
  loading: boolean;
  setLoading: (state: any) => void;
  toggle: () => void;
}) => {
  const simpleBarRef: any = useRef(null);

  useEffect(() => {
    if (simpleBarRef.current) {
      const simpleBarInstance = simpleBarRef.current.getScrollElement();
      simpleBarInstance.scrollTop = simpleBarInstance.scrollHeight;
    }
  }, []);

  return (
    <Form
      className="tablelist-form"
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
      }}
    >
      <ModalBody className="px-0 py-0">
        <Row>
          <Col md={12} className="mb-3">
            <SimpleBar
              ref={simpleBarRef}
              style={{ maxHeight: "70vh" }}
              className=" px-4 py-4"
              autoHide={false}
            >
              {validation.values.classifiedInformation.map(
                (classifiedInformation: any, index: number) => (
                  <Card className="bg-light" key={index}>
                    <CardBody>
                      <Row>
                        <Col>
                          <SelectCIType validation={validation} index={index} />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} className="mb-3">
                          <Label
                            htmlFor={`date-${index}`}
                            className="form-label"
                          >
                            Date
                          </Label>
                          {/* @ts-ignore */}
                          <Flatpickr
                            name={`classifiedInformation[${index}].date`}
                            id={`date-${index}`}
                            className={
                              validation.touched?.classifiedInformation &&
                              validation.touched?.classifiedInformation[index]
                                ?.date &&
                              validation.errors?.classifiedInformation &&
                              validation.errors?.classifiedInformation[index]
                                ?.date
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            placeholder="Select start date"
                            options={{
                              enableTime: false,
                              altInput: false,
                              altFormat: "d M, Y",
                              dateFormat: "d M, Y",
                            }}
                            onChange={(e) => {
                              if (e[0]) {
                                validation.setFieldValue(
                                  `classifiedInformation[${index}].date`,
                                  e[0]
                                );
                                validation.setFieldError(
                                  `classifiedInformation[${index}].date`,
                                  ""
                                );
                              } else {
                                validation.setFieldValue(
                                  `classifiedInformation[${index}].date`,
                                  null
                                );
                              }
                            }}
                            value={
                              validation.values?.classifiedInformation[index]
                                ?.date || ""
                            }
                          />

                          {validation.touched?.classifiedInformation &&
                          validation.touched?.classifiedInformation[index]
                            ?.date &&
                          validation.errors?.classifiedInformation &&
                          validation.errors?.classifiedInformation[index]
                            ?.date ? (
                            <FormFeedback type="invalid">
                              {
                                validation.errors?.classifiedInformation[index]
                                  ?.date
                              }
                            </FormFeedback>
                          ) : null}
                        </Col>
                        <Col md={6} className="mb-3">
                          <SelectAgency
                            validation={validation}
                            setLoading={setLoading}
                            label="Reporting Agency"
                            index={index}
                          />
                        </Col>

                        <Col md={12} className="mb-3">
                          <Label
                            htmlFor={`classifiedInformation[${index}].description`}
                            className="form-label"
                          >
                            Reason/Description
                          </Label>
                          <Input
                            name={`classifiedInformation[${index}].description`}
                            id={`classifiedInformation[${index}].description`}
                            className="form-control"
                            placeholder="Enter description"
                            type="textarea"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={classifiedInformation.description || ""}
                            invalid={
                              validation.touched.classifiedInformation?.[index]
                                ?.description &&
                              validation.errors.classifiedInformation?.[index]
                                ?.description
                                ? true
                                : false
                            }
                          />
                          {validation.touched.classifiedInformation?.[index]
                            ?.description &&
                          validation.errors.classifiedInformation?.[index]
                            ?.description ? (
                            <FormFeedback type="invalid">
                              {
                                validation.errors.classifiedInformation[index]
                                  .description
                              }
                            </FormFeedback>
                          ) : null}
                        </Col>
                        <div className="d-flex justify-content-end">
                          <Button
                            className="btn btn-sm btn-soft-danger waves-effect waves-light material-shadow-none"
                            onClick={() => {
                              validation.setFieldValue(
                                "classifiedInformation",
                                validation.values.classifiedInformation.filter(
                                  (
                                    _: any,
                                    classifiedInformationIndex: number
                                  ) => classifiedInformationIndex !== index
                                )
                              );
                            }}
                          >
                            {/* <i className="ri-delete-bin-fill me-2"></i> */}
                            Remove
                          </Button>
                        </div>
                      </Row>
                    </CardBody>
                  </Card>
                )
              )}
              <button
                className="btn btn-soft-secondary  waves-effect waves-light material-shadow-none"
                disabled={false}
                onClick={() => {
                  if (true) {
                    const newClassifiedInformation = {
                      classifiedInformationType: {
                        value: "",
                        label: "",
                      },
                      description: "",
                      reportingAgency: {
                        value: "",
                        label: "",
                      },
                      date: null,
                    };
                    validation.setFieldValue("classifiedInformation", [
                      ...validation.values.classifiedInformation,
                      newClassifiedInformation,
                    ]);
                  }
                }}
              >
                Add
              </button>
            </SimpleBar>
          </Col>
        </Row>
      </ModalBody>

      <div className="modal-footer">
        <div className="hstack gap-2 justify-content-end">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              toggle();
            }}
          >
            Close
          </button>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading && (
              <Spinner
                color="light"
                size="sm"
                style={{ marginRight: "8px", marginBottom: "-1px" }}
              ></Spinner>
            )}
            {"Save Changes"}
          </button>
        </div>
      </div>
    </Form>
  );
};

export default ClassifiedinformationForm;
